"use client";

import { Dialog, DialogContent, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { IME_SERIOUSNESS_TEXT } from "../constants/imeSeriousnessLabels";
import type { ImeConfirmation } from "../model/imeSeriousness";

interface Props {
  /** The confirmation while it is open; null while it is closed. */
  confirmation: ImeConfirmation | null;
  onAccept: () => void;
  onCancel: () => void;
}

/**
 * Confirms "Derive seriousness from the EMA IME list" for one event.
 *
 * Dumb: it draws the lines it is given and calls back. Accept stays disabled until the list is read, so an accept
 * never applies values that nobody has seen.
 */
export function ImeSeriousnessDialog({ confirmation, onAccept, onCancel }: Props) {
  return (
    <Dialog open={confirmation !== null} onOpenChange={(next) => !next && onCancel()}>
      <DialogContent className="cr-portal cr-dialog">
        <DialogHeader>
          <DialogTitle>{IME_SERIOUSNESS_TEXT.title}</DialogTitle>
        </DialogHeader>

        <div className="cr-dialog-body">
          {confirmation?.status === "ready"
            ? confirmation.lines.map((line, position) => (
              <p key={line} className={position === 0 ? "cr-dialog-text" : "cr-dialog-note"}>{line}</p>))
            : confirmation?.status === "failed"
              ? <p className="cr-dialog-text" role="alert">{confirmation.message}</p>
              : <p className="cr-dialog-text" role="status">{confirmation?.message}</p>}
        </div>

        <DialogFooter>
          <Button variant="outline" size="sm" onClick={onCancel}>{IME_SERIOUSNESS_TEXT.cancel}</Button>
          <Button size="sm" onClick={onAccept} disabled={confirmation?.status !== "ready"}>
            {IME_SERIOUSNESS_TEXT.accept}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
